import { resetRequestsForNewAddressActionCreator } from 'src/state/request/action-creators/reset-requests-for-new-address-action-creator';
import { resetNewAccount } from 'src/state/request/request-slice';
import { AppDispatch } from 'src/state/types';

export const resetRequestsForNewAccountActionCreator = () => (dispatch: AppDispatch) => {
  dispatch(resetNewAccount());
  dispatch(resetRequestsForNewAddressActionCreator());
};
